import { render, staticRenderFns } from "./ListPackage.vue?vue&type=template&id=318f51cf&scoped=true"
import script from "./ListPackage.vue?vue&type=script&lang=js"
export * from "./ListPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318f51cf",
  null
  
)

export default component.exports